jQuery(document).ready(function ($) {
  // 使用事件委托来监听所有可能的点击

  $(document).on(
    "click",

    '.wpcf7-list-item-label, .wpcf7-list-item input[type="radio"]',

    function (e) {
      var $input;

      if ($(this).is("input")) {
        $input = $(this);
      } else {
        $input = $(this).siblings('input[type="radio"]');
      }

      var name = $input.attr("data-name");

      var value = $input.val();

      // 根据name更新对应的显示元素

      switch (name) {
        case "mtsi_method":
          $("#fetch_sel_method_insta_txt1").text(value);

          break;

        case "mtsi_header_type":
          $("#fetch_sel_header_type_txt1").text(value);

          break;

        case "mtsi_panel_type":
          $("#fetch_sel_panel_txt1").text(value);

          break;

        case "mtsi_custom_curtain_lining":
          $("#fetch_sel_lining_txt1").text(value);

          break;
      }
    }
  );

  var whStep = $('div.steps-step:contains("W & H")');

  if (whStep.length && !whStep.find("#fetch_sel_width_height_txt1").length) {
    whStep.append('<p id="fetch_sel_width_height_txt1"></p>');
  }

  var liningStep = $('div.steps-step:contains("Lining")');

  if (liningStep.length && !liningStep.find("#fetch_sel_lining_txt1").length) {
    liningStep.append('<p id="fetch_sel_lining_txt1"></p>');
  }

  function updateWidthHeight() {
    var width = $("#mtsi_custom_curtain_width").val() || "";

    var height = $("#mtsi_custom_curtain_height").val() || "";

    var unit = $("#mtsi_custom_curtain_width_unit").val();

    $("#fetch_sel_width_height_txt1").text("W" + width + " " + "H" + height);
  }

  // 监听宽度和高度的变化

  $(document).on(
    "change",

    'input[id="mtsi_custom_curtain_width"], input[id="mtsi_custom_curtain_height"]',

    function () {
      // 确保输入值不为负

      if (parseFloat(this.value) < 0) {
        this.value = "0";
      }

      updateWidthHeight();
    }
  );

  // 监听单位选择的变化

  $(document).on("change", "#mtsi_custom_curtain_width_unit", function () {
    updateWidthHeight();
	  $("#mtsi_custom_unit").val($(this).val());
  });

  // 防止输入负数

  $(
    'input[data-name="mtsi_custom_curtain_width"], input[data-name="mtsi_custom_curtain_length"]'
  ).on("input", function () {
    if (this.value.startsWith("-")) {
      this.value = this.value.substring(1);
    }
  });

  // 同步单位选择

  $(".unit-select").on("change", function () {
    var selectedValue = $(this).val();

    $(".unit-select").val(selectedValue);

    // 更新隐藏的输入字段，用于表单提交

    $("#mtsi_custom_curtain_unit").val(selectedValue);

    // 触发自定义事件，以便其他可能依赖于单位的函数可以更新

    $(document).trigger("unitChanged", [selectedValue]);
  });

  // 初始化单位选择

  var initialUnit = $("#mtsi_custom_curtain_unit").val() || "inches"; // 假设有一个隐藏的输入字段存储初始单位

  $(".unit-select").val(initialUnit);

  // 第五步

  var linerData = {
    liner: [
      {
        mtsi_liner_color_name: "White",

        mtsi_liner_color_group: "#ffffff",
      },

      {
        mtsi_liner_color_name: "Beige",

        mtsi_liner_color_group: "#f4ebcd",
      },

      {
        mtsi_liner_color_name: "Natural Beige",

        mtsi_liner_color_group: "#d6ccbe",
      },

      {
        mtsi_liner_color_name: "Light Grey",

        mtsi_liner_color_group: "#dbdbdb",
      },

      {
        mtsi_liner_color_name: "Medium Grey",

        mtsi_liner_color_group: "#bcbcbc",
      },

      {
        mtsi_liner_color_name: "Black",

        mtsi_liner_color_group: "#000000",
      },
    ],
  };

  console.log("Liner Data:", linerData);

  // 预加载图片

  var imageUrlTemplate = "https://cdn.shopify.com/s/files/1/0847/3375/5585/files/liner_";

  var preloadedImages = {};

  function preloadImages() {
    // 预加载默认的 Liner 图片

    preloadedImages["default"] = new Image();

    preloadedImages["default"].src =
      "https://cdn.shopify.com/s/files/1/0847/3375/5585/files/curtains_Liner.jpg?v=1765186009";

    // 预加载所有颜色的 Liner 图片

    linerData.liner.forEach(function (color) {
      var colorName = color.mtsi_liner_color_name

        .toLowerCase()

        .replace(/\s/g, "");

      preloadedImages[colorName] = new Image();

      preloadedImages[colorName].src = imageUrlTemplate + colorName + ".jpg";
    });
  }

  preloadImages();

  $('input[data-name="mtsi_custom_curtain_lining"]').change(function () {
    var selectedLining = $(this).val();

    var $colorContainer = $(".liner-color-container");

    if (
      selectedLining === "Liner" &&
      linerData["liner"] &&
      linerData["liner"].length > 0
    ) {
      var colorHtml =
        '<div class="mtsi-liner-color-swatches" data-lining-item="liner"><p>Liner Color: </p>';

      $.each(linerData["liner"], function (index, color) {
		  var checked='';
			if(index<1){
				checked='checked';
			}
        colorHtml +=
          '<label class="liner-color-radio">' +
          '<input type="radio" data-name="mtsi_liner_color_swatch" name="properties[Liner Color]" data-color-name="' +
          color.mtsi_liner_color_name +
          '" value="' +
          color.mtsi_liner_color_group +
          '" id="mtsi_liner_color_swatch_' +
          index +
			  '" '+
			  checked+
			  '/>' +
          '<span class="liner-color-swatch" data-color-name="' +
          color.mtsi_liner_color_name +
          '" style="background-color: ' +
          color.mtsi_liner_color_group +
          '">' +
          "</span>" +
          "</label>";
      });

      colorHtml += "</div>";

      $colorContainer.html(colorHtml).show();
    } else {
      $colorContainer.hide().empty();
    }

    // 更新 Liner 选项的图片

    updateLinerImage(selectedLining);
  });

  // 初始化时触发一次change事件，以设置初始状态

  $('input[data-name="mtsi_custom_curtain_lining"]:checked').trigger("change");

  // 处理颜色选择

  $(document).on("click", ".liner-color-radio", function (event) {
    var input = event.currentTarget.querySelector("input");

    var colorName = input.getAttribute("data-color-name");

    if (colorName !== "undefined") {
      document.getElementById('hiddenLinerColor').value = colorName ?? '';
      colorName = colorName.toLowerCase().replace(/\s/g, "");
      updateLinerImage("Liner", colorName);
    }
  });

  function updateLinerImage(selectedLining, colorName) {
    var $linerLabel = $(
      '#mtsi_custom_curtain_lining input[type="radio"][value="Liner"] + .wpcf7-list-item-label'
    );

    if (selectedLining === "Liner") {
      var imageUrl = colorName
        ? preloadedImages[colorName].src
        : preloadedImages["default"].src;

      $linerLabel.css({
        content: "url(" + imageUrl + ")",

        cursor: "pointer",

        width: "150px",

        display: "inline-block",
      });
    } else {
      $linerLabel.css({
        content: "",

        cursor: "default",

        display: "inline",
      });
    }
  }

  let isUserScrolling = false;
  let lastScrollTop = 0;
  const scrollThreshold = 100; // 允许的最大自动滚动距离

  // 在 DOMContentLoaded 事件中设置初始滚动位置
  document.addEventListener("DOMContentLoaded", function () {
    lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // 如果页面已经滚动，则立即滚回顶部
    if (lastScrollTop > 0) {
      window.scrollTo(0, 0);
    }
  });

  // 监听用户的滚动事件
  window.addEventListener("wheel", function () {
    isUserScrolling = true;
    setTimeout(function () {
      isUserScrolling = false;
    }, 100);
  });

  window.addEventListener("touchmove", function () {
    isUserScrolling = true;
    setTimeout(function () {
      isUserScrolling = false;
    }, 100);
  });


	// 只有窗帘需要执行
  if ($('.uacf7-multisetp-form').length) {
	  
  // Event listeners for all form inputs
  $('input[type="radio"], input[type="number"], select').on(
    "change input",
    function () {
    }
  );
  
	}

  // Optional: Add a custom message when trying to click a disabled button
  $(".single_add_to_cart_button").on("click", function (e) {
    if ($(this).prop("disabled")) {
      // e.preventDefault();
      // alert("Please complete all curtain options before adding to cart.");
    }
  });

});
